<template>
  <el-menu
    class="doc-sidebar"
    :default-active="defaultPath"
    :text-color="textColor"
    :active-text-color="activeTextColor"
    :unique-opened="uniqueOpened"
    :background-color="backgroundColor || ''"
    :default-openeds="defaultOpenedMenus"
    @select="onSelect"
  >
    <SubMenu
      :nav-list="navList"
    />
  </el-menu>
</template>
<script>
import SubMenu from './sub-menu';

export default {
  name: 'Sidebar',
  components: {
    SubMenu
  },
  props: {
    navList: {
      default() {
        return [];
      },
      type: Array
    },
    defaultPath: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: '#1B202C'
    },
    activeTextColor: {
      type: String,
      default: '#0062FF'
    },
    uniqueOpened: {
      type: Boolean,
      default: false
    },
    openedDepth: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      defaultOpenedMenus: [],
    };
  },
  mounted() {
    if (this.openedDepth > 0) {
      this.defaultOpenedMenus = this.handleOpenedMenus(this.navList, this.openedDepth);
    }
  },
  methods: {
    isExternalLink(link) {
      if (typeof link !== 'string') {
        return false;
      }
      if (link.indexOf('https') === 0 || link.indexOf('http') === 0) {
        return true;
      }
      return false;
    },
    onSelect(path) {
      if (!this.isExternalLink(path) && this.$router) {
        this.$router.push(path);
      }
      this.$emit('select', path);
    },
    handleOpenedMenus(menuList, depth = 2, openedList = []) {
      if (!Array.isArray(menuList) || depth === 0) return;
      depth -= 1;
      menuList.forEach(menu => {
        const { isGroupTitle, subNavList, path } = menu;
        if (!isGroupTitle && subNavList.length > 0) {
          openedList.push(path);
          this.handleOpenedMenus(subNavList, depth, openedList);
        }
      });

      return openedList;
    }
  }
};
</script>
<style lang="scss">
  .doc-sidebar .collapse-transition {
    transition: 0s;
  }
  .doc-sidebar {
    padding: 0 10px;
    &.el-menu {
      border-right: none;
    }
    .el-menu-item, .el-submenu__title {
      height: 44px;
      line-height: 44px;
    }
    .el-submenu {
      .el-menu-item {
        /* padding-left: 42px !important; */
        height: 44px;
        line-height: 44px;
        font-weight: 400;
        font-family: PingFangSC-Regular, PingFang SC;
      }
      .el-submenu__title {
        font-weight: 500;
      }
    }
    .el-menu-item {
      font-weight: 500;
    }
    .el-menu-item:focus, .el-menu-item:hover {
      outline: 0;
      background-color: #F2F4F8;
    }
    .el-menu-item:active {
      outline: 0;
      background-color: #E6EAEE;
    }
    .el-menu-item.is-active {
      background: #EBF2FF;
      font-weight: 500;
      border-radius: 3px;
    }
    .el-menu-item-group__title {
      padding-left: 42px !important;
    }
    .el-submenu__title {
      &:hover {
        background-color: #F2F4F8;
      }
    }
    .el-menu-item-group__title {
      font-size: 12px;
      color: #929AAB;
      line-height: 12px;
    }
    .el-icon-arrow-down {
      background: url(./img/arrow_black_down@2x.png) no-repeat;
      background-size: 10px 10px;
      width: 10px;
      height: 10px;
      margin-top: -5px;
      &::before {
        content: '';
      }
    }
  }
</style>
